import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
export type FetchedUserFragment = (
  { __typename?: 'User' }
  & Pick<Types.User, 'objectId' | 'fullName' | 'firstName' | 'lastName'>
);

export const FetchedUserFragmentDoc = gql`
    fragment FetchedUser on User {
  objectId
  fullName
  firstName
  lastName
}
    `;